import styled from "styled-components";
import { FooterModule, HeaderModule } from "@module";

interface IAppModuleLayout {
    children?: string | JSX.Element | JSX.Element[];
    onBack?: () => void;
}

export const AppModuleLayout = (props: IAppModuleLayout) => {
    const { children } = props;

    return (
        <AppLayoutWrapper>
            <HeaderModule />
            {!!children && children}
            <FooterModule />
        </AppLayoutWrapper>
    );
};

const AppLayoutWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: ${(props) => props.theme.colors.gray_6};
`;
